import React, { FC, useCallback, useState } from 'react';

import { Link, Text } from '@nord/ui';

import SVG from '../../atoms/SVG';
import Input from './Input';
import { IPasswordFieldProps } from './interfaces';

const PasswordField: FC<IPasswordFieldProps> = ({ label, linkProps, ...rest }) => {
  const [type, setState] = useState('password');
  const isTypePassword = type === 'password';
  const handleClick = useCallback(() => {
    setState(isTypePassword ? 'text' : 'password');
  }, [isTypePassword]);

  const labelWithToggle = (
    <div className="flex justify-between">
      <Text variant="caption">{label}</Text>
    </div>
  );

  const suffix = (
    <Link
      component="span"
      onClick={handleClick}
      underline
      className="text-grey px-3 mx-2"
      {...linkProps}
    >
      <SVG
        src={`images/global/icons/16/${isTypePassword ? 'eye' : 'eye-disabled'}.svg`}
        title={isTypePassword ? 'Show password' : 'Hide password'}
      />
    </Link>
  );
  return <Input type={type} label={labelWithToggle} suffix={suffix} {...rest} />;
};

export default PasswordField;
